var React = require('react');

function Maximize (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"20","cy":"20","r":"18.5","fill":"white","stroke":"black","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M11 11H17V13H14.4617L19.3047 17.843L17.8905 19.2572L13 14.3667V17H11V11Z","fill":"black","key":1}),React.createElement("path",{"d":"M11 29H17V27H14.3764L19.3046 22.0718L17.8904 20.6576L13 25.548V23H11V29Z","fill":"black","key":2}),React.createElement("path",{"d":"M23 29H29V23H27V25.5244L22.1332 20.6576L20.719 22.0718L25.6472 27H23V29Z","fill":"black","key":3}),React.createElement("path",{"d":"M29 11H23V13H25.5619L20.7189 17.843L22.1331 19.2572L27 14.3903V17H29V11Z","fill":"black","key":4})]);
}

Maximize.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Maximize;

Maximize.default = Maximize;
